import withLoadingData from "./with-loading-data";
import withLocalization from "./with-localization";
import withSignalGetter from "./with-signal-getter";

const HOC = {
    withLoadingData,
    withLocalization,
    withSignalGetter
};
export default HOC;
